// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"aabfb449","361":"ea1cc6e9","368":"6978c2f8","447":"d7adb09d","455":"3b39d056","629":"1987a823","637":"bb18010f","639":"5033c71a","719":"19396adb","771":"7ecd56b7","899":"29815cd1","937":"5966dd3f","977":"6e736b7d"}[chunkId] + ".chunk.js";
};